import { TradeTapeItem } from '@paradigm/features/src/unified-rfqs/entities/shared';

/**
 * Format a UnifiedRfqs trade-tape row as a chat prompt for the agent.
 *
 * Emits the terminal `/analyze <rfq id> <trade description>` command.
 * Both union branches carry a human-readable `description`, so we hand the
 * agent the rfq id (to look up full details if it needs them) plus that
 * summary rather than a verbose prose instruction and JSON dump. The system
 * preamble passed by BlockTerminalTab already tells the agent the surrounding
 * context (paradigm options, RFQ flow, etc.).
 */
export function buildTradeAnalysisPrompt(trade: TradeTapeItem): string {
  return `/analyze ${trade.rfq_id} ${trade.description}`;
}
